import { RootState } from "../../store";

export const getBlocks = (store: RootState) => store.about.blocks;
export const getIsLoading = (store: RootState) => store.albums.isLoading;